<template>
  <div class="menubar">

    <div class="seperation-line-bottom" style="flex: 0 0 50px;">
      <router-link to="/" class="navbar-brand" @click.native="logoWave">
        <img v-show="!show_wave" src="@/assets/menubar/logo_menubar_bw.svg" alt="Goalpilot" class="is-fullsize" />
        <img v-show="show_wave" src="@/assets/menubar/logo_menubar_bw_wave.svg" alt="Goalpilot" class="is-fullsize" />
      </router-link>
    </div>

    <menubar-search v-if="show_search || true" />

    <menubar-profile />

    <menubar-navigation class="seperation-line-bottom" />

    <menubar-goals class="seperation-line-bottom" />

    <menubar-team class="spacing-bottom" />

    <el-button v-if="show_trial_ends_button" class="trial-button" @click="$router.push('/upgrade')">Trial ends in 41 days</el-button>

    <!--
    <div style="height: 2000px; width: 5px; background-color: white">
      <p v-for="n in 125">{{n}}</p>
    </div>
    -->

    <menubar-footer />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

// TODO: Show loading animation, when route is chaning

import {
  FEATURE_SHOW_DEVELOPER_TOOLBAR,
  FEATURE_ENABLE_SEARCH } from '@/features'

import MenubarFooter from './Elements/MenubarFooter.vue'
import MenubarGoals from './Elements/MenubarGoals.vue'
import MenubarNavigation from './Elements/MenubarNavigation.vue'
import MenubarProfile from './Elements/MenubarProfile.vue'
import MenubarSearch from './Elements/MenubarSearch.vue'
import MenubarTeam from './Elements/MenubarTeam.vue'

export default {
  data() {
    return {
      show_wave: false,
      show_search: FEATURE_ENABLE_SEARCH,
      show_developer_toolbar: FEATURE_SHOW_DEVELOPER_TOOLBAR,
      show_trial_ends_button: true,
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters("app", [
      'sidebar',
    ]),

    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  methods: {
    ...mapMutations('app', ['SET_ACTIVE_TOPBAR_MENU']),

    logoWave() {
      setTimeout(() => { this.show_wave = true }, 200)
      setTimeout(() => { this.show_wave = false }, 500)
    },

  },
  components: {
    MenubarFooter,
    MenubarGoals,
    MenubarNavigation,
    MenubarProfile,
    MenubarSearch,
    MenubarTeam,
  }
}
</script>

<style lang="scss">
@import './Style/menubar.scss';
</style>
